// extracted by mini-css-extract-plugin
export default {"card":"GalleryCard_card__1WkEu","cardInfoWrapper":"GalleryCard_cardInfoWrapper__qb6gz","cardName":"GalleryCard_cardName__VcgTI","cardInfo":"GalleryCard_cardInfo__z0baE"};